module.exports = __webpack_public_path__ + "static/logo-bank-bri-25f347d7a58c59bfcf1543efa0240dd7.png";